/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { uniqueId } from 'lodash';
import { HelpRequest } from '../../resources';

@Injectable()
export class BugRequestFormState extends FormState<HelpRequest> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(request: HelpRequest, { root, array, group }: FormStateSchema): FormRootSchema {
    return root({
      enabled: true,
      children: {
        mode: void 0,
        subject: { required: true },
        description: { required: true },
        attachScreenshot: void 0,
        masterZoneName: void 0,
        officeName: void 0,
        priority: { required: true },
        login: void 0,
        buildNumber: void 0,
        date: void 0,
        attachments: array({
          enabled: true,
          children: request.attachments.map(() => group({
            key: uniqueId('attachment:'),
            children: {
              body: void 0,
              name: void 0,
              contentType: void 0,
              encode: void 0,
            },
          })),
        }),
      },
    });
  }

}
